import React, { useState, useRef, useEffect } from "react";
import InputMask from "react-input-mask";
import { Form, Alert, InputGroup } from "react-bootstrap";
import { useProvider, Toast, isNative } from '../../context/MenuProvider';

const PhoneInput = ({ phone, setPhone, formErrors, is_obrigatorio = false, label = "WhatsApp", placeholder = "" }) => {
  const [editando, setEditando] = useState(false);
  const inputRef = useRef(null); // Referência para o campo de número
  
  const {
    handleNormalizarTelefone
  } = useProvider();
  
  const handlePhoneChange = (e) => {
    const phoneValue = e.target.value;
    setPhone(phoneValue);

    // Remove caracteres não numéricos para validação
    const digitsOnly = handleNormalizarTelefone(phoneValue); //normqlizadoretorna 13 caracteres

    // Verifica se há exatamente 11 dígitos ou se pode estar vazio
    if (is_obrigatorio ? digitsOnly.length === 13 : digitsOnly.length === 13 || digitsOnly.length === 0) {
      formErrors.phone = ""; // Telefone válido
    } else if(digitsOnly > 0) {
      formErrors.phone = `${label} inválido`;
    }
  };

  const handleNumberChange = (e) => {
    let value = e.target.value.replace(/\D/g, ""); // Remove qualquer caractere não numérico
    if (parseInt(value || 0) <= 99999999999) {
      setPhone(value);
    }
  };

  const handleFocus = () => {
    setEditando(true);
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus(); // Garante que o campo de número seja focado automaticamente
      }
    }, 0);
  };
  
  useEffect(() => {
    if(editando) return;
    setPhone(handleNormalizarTelefone(phone).slice(-11))
  }, [editando])

  return (
    <Form.Group controlId="phone" className="my-3">
      <InputGroup>
        {label && (
          <span className="input-group-text">{label} {is_obrigatorio && "*"}</span>
        )}
        {editando ? (
          <Form.Control
            ref={inputRef}
            value={phone?.replace(/\D/g, "")}
            type="number"
            onChange={handleNumberChange}
            onBlur={(e) => setEditando(false)}
            placeholder={placeholder}
          />
        ) : (
          <InputMask
            mask="(99) 99999-9999"
            value={phone}
            onChange={handlePhoneChange}
            onFocus={handleFocus} // Ao focar, ativa o modo de edição imediatamente
          >
            {(inputProps) => <Form.Control {...inputProps} type="text" placeholder={placeholder || "(__) _____-____"} />}
          </InputMask>
        )}
      </InputGroup>
      {formErrors.phone && <Alert variant="danger">{formErrors.phone}</Alert>}
    </Form.Group>
  );
};

export default PhoneInput;